export const NHSR_ROLES = ["Administrator"]
export const OSR_ROLES = ["Administrator"]
export const UNIT_DASHBOARD_ROLES = ["Educator", "Metrics & Reports", "Administrator"]
export const SYSTEM_DASHBOARD_ROLES = ["Metrics & Reports", "Administrator"]
